module.exports = __webpack_public_path__ + "img/cn_4.8527b11c.jpg";